import React from 'react'
import { Desc, Head2 } from '../../../../../Components/Typography/Text.styles'
import { colors } from '../../../../../Components/consts'
import { ExplainersCon } from './styles'

export const FastestShot: React.FC = () => {
  return (
    <ExplainersCon>
      <Head2 textColor={colors.gray.gray20}>{`Rounds`}</Head2>
      <ul>
        <li>
          <Desc textColor={colors.gray.gray20}>{`Round 1: 4x Athletes per League`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`Round 2: 2x Fastest Shots in Round 1, per League`}</Desc>
        </li>
        <li>
          <Desc
            textColor={colors.gray.gray20}
          >{`Each athlete gets 2 shots from 10 yards; only goals count, and the faster of the two is recorded. Top speeds advance.`}</Desc>
        </li>
        <li>
          <Desc
            textColor={colors.gray.gray20}
          >{`Finals tiebreaker: One extra shot per tied athlete`}</Desc>
        </li>
      </ul>
      <Head2 textColor={colors.gray.gray20}>{`Former Winners`}</Head2>
      <ul>
      <li>
          <Desc textColor={colors.gray.gray20}>{`2024: Jarrod Neumann`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2023: Jarrod Neumann`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2022: Jarrod Neumann`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2021: Marcus Holman`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2019: Jarrod Neumann`}</Desc>
        </li>
      </ul>
    </ExplainersCon>
  )
}
